import { get } from 'lodash'

export const iso3FromIso2 = {
  en: 'ENG',
  ru: 'RUS',
  es: 'SPA',
  de: 'DEU',
  uk: 'UKR'
}

export const iso2FromIso3 = {
  ENG: 'en',
  RUS: 'ru',
  SPA: 'es',
  DEU: 'de',
  UKR: 'uk'
}

export const getIso2FromIso3 = (lang) => {
  if (lang.length === 2) return lang

  return get(iso2FromIso3, lang, 'en')
}

export const getIso3FromIso2 = (lang) => {
  if (lang.length === 3) return lang

  return get(iso3FromIso2, lang, 'ENG')
}
